const name = 'BaseRotate';
const properties = {};
const supportedDirections = {
    cw: true,
    ccw: true,
    short: true,
};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    const { to, from } = params;
    if (to &&
        typeof to.rotation !== 'undefined' &&
        supportedDirections[to.direction]) {
        params.to.rotation = `${to.rotation}_${to.direction}`;
    }
    if (from &&
        typeof from.rotation !== 'undefined' &&
        supportedDirections[from.direction]) {
        params.from.rotation = `${from.rotation}_${from.direction}`;
    }
    return kit.engine.tween(elements, { duration, delay, ...params }, [
        'rotation',
    ]);
}
export { name, properties, animate };
//# sourceMappingURL=baseRotate.js.map